/*
  Created by Justin Chang
*/
// import demoCampaign from '../../pages/data/demoCampaign';

import update from '../update';

import {
  SET_CAMPAIGNS,
  COMPLETE_CAMPAIGN,
  RATE_CAMPAIGN
} from './constants';


var initialState = null;
  // {
  //   totalValue: 0,
  //   totalEng: 0,
  //   brandId: '',
  //   brandName: '',
  //   brandColor: '',
  //   brandLogoID: '',
  //   brandLogoURL: '',
  //   brandLogoThumbURL: '',
  //   id: '', // campaign id
  //   name: '',
  //   feedtext: '',
  //   feedimageurl: '',
  //   introtext: '',
  //   introimageurl: '',
  //   completiontext: '',
  //   engagements: [ // List of engagements for this campaign
  //     {
  //       id:              '',
  //       name:            '',
  //       campaignId:      '',
  //       ordinal:         0,
  //       kind:            '',
  //       firstImageURL:   '',
  //       secondImageURL:  '',
  //       videoURL:        '',
  //       options: [
  //         {
  //           id:       '',
  //           answer:   '',
  //           answerId: ''
  //         }
  //       ]
  //     }
  //   ]
  // }

// initialState = [
//   {...demoCampaign, id: 0},
//   {...demoCampaign, id: 1},
//   {...demoCampaign, id: 2},
//   {...demoCampaign, id: 3}
// ];

/*
  Only adds all campaigns or deletes one campaign from the list
*/
const campaignsReducer = (state=initialState, action) => {
  switch (action.type) {

    case SET_CAMPAIGNS:
      return update(state, {$set: action.payload});
    case COMPLETE_CAMPAIGN:
      let experiences = state.slice()
      let indexToInsert = -1
      let indexOfItem = -1
      for (let i = 0; i < experiences.length; i++) {
        if (experiences[i].id === action.payload) {
          indexOfItem = i
        }
        if (experiences[i].campaignComplete) {
          indexToInsert = i
          break
        }
      }
      let item = experiences.splice(indexOfItem, 1)[0]
      item.campaignComplete = true
      indexToInsert = (indexToInsert === -1) ? experiences.length : (indexToInsert - 1)
      experiences.splice(indexToInsert, 0, item);
      return experiences
        // return state.map((item) => item.id === action.payload ? {...item, campaignComplete: true} : item).sort(sortCompare)
    case RATE_CAMPAIGN:
      return state.map((item) => item.id === action.payload.campaignId ? {...item, userRating: action.payload.userRating} : item)
    default:
      return state;
  }
}

export default campaignsReducer;



// WEBPACK FOOTER //
// ./src/redux/campaigns/reducer.js